import { tw } from '@/lib/tailwind';

export const AuthError = ({ message, retry }: { message: string; retry: () => void }) => (
  <div
    className={tw('flex h-screen flex-col items-center justify-center gap-4')}
    aria-label="Initialization error"
  >
    <p className="text-destructive-600">Failed to initialize authentication.</p>
    <pre
      className="max-w-md text-xs whitespace-pre-wrap text-gray-500"
      aria-label="Error details"
    >
      {message}
    </pre>
    <button
      type="button"
      className="text-primary-700 underline"
      onClick={retry}
    >
      Retry
    </button>
  </div>
);
